import React, { useContext, useState, useEffect } from "react";
import { Divider, IconButton, Paper } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { storage } from "../../firebase.js";
import { useSnackbar } from "notistack";
import { ContextGlobal } from "../../context";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import axios from "axios";
import firebase from "firebase";
import "./mydocs.css";
import { config } from "../../config.js";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: { display: "flex", margin: "10px", position: "relative" },
}));

const imageRemove = {
  borderRadius: "50%",
  width: "22px",
  height: "22px",
  padding: "0",
  position: "absolute",
  right: "-7px",
  top: "-7px",
  zIndex: "10",
  background: "red",
  border: "none",
  color: "white",
  fontSize: "18px",
  fontWeight: "bold",
  cursor: "pointer",
};

const MyDocs = (props) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { data, setData } = useContext(ContextGlobal);
  const [showDiv, setShowDiv] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [modalState, setModalState] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const mydocObj =
    props.patientData === undefined || props.patientData.data === undefined
      ? props.xray
        ? data.data.xrays
        : data.data.prescriptions
      : props.xray
      ? props.patientData.data.xrays
      : props.patientData.data.prescriptions;

  const myDocs__handleOpenClose = (url) => {
    setModalState(!modalState);
    setModalImage(url);
  };

  const fileSelectedHandler = (e) => {
    let file = e.target.files;
    setSelectedFiles(file);
  };

  const MyDocsUpload = () => {
    const promises = [];
    var Files = [...selectedFiles];
    Files.forEach((file) => {
      const uploadTask = storage
        .ref()
        .child(
          `images/${data.data.uid}/${props.xray ? "xrays" : "prescriptions"}/${
            file.name
          }`
        )
        .put(file);
      promises.push(uploadTask);
      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          if (snapshot.state === firebase.storage.TaskState.RUNNING) {
            // console.log(`Progress: ${progress}%`); //console
            enqueueSnackbar(`Uploading ${progress}%...`, {
              variant: "warning",
            });
          }
        },
        (error) => console.log(error.code),
        async () => {
          const downloadURL = await uploadTask.snapshot.ref.getDownloadURL();
          axios
            .post(`${config.url.BACKEND}/uploadDocs`, {
              uid: `${data.data.uid}`,
              branch: `${props.xray ? "xrays" : "prescriptions"}`,
              url: downloadURL,
            })
            .then((res) => {
              setData(res.data);
              enqueueSnackbar("Successfully uploaded!", { variant: "success" });
            })
            .catch((error) => {
              enqueueSnackbar(error, { variant: "error" });
              console.log(error);
            });
        }
      );
    });
    Promise.all(promises)
      .then(() => {
        console.log("All files uploaded");
        setShowDiv(false);
      })
      .catch((err) => console.log(err.code));
  };

  const removeImage = (url) => {
    var str = decodeURIComponent(url);
    var start = str.indexOf("images");
    var end = str.indexOf("?");
    str = str.slice(start, end);
    Object.keys(mydocObj).map((x, i) => {
      if (mydocObj[x].url === url) {
        delete mydocObj[`${x}`];
      }
      return "";
    });
    var deleteRef = storage.ref().child(str);
    enqueueSnackbar("Deleting....", { variant: "info" });
    deleteRef
      .delete()
      .then(() => {
        axios
          .post(`${config.url.BACKEND}/updateUser`, data.data)
          .then((res) => {
            setData(res.data);
            enqueueSnackbar("Successfully Deleted!", { variant: "success" });
          })
          .catch((error) => {
            enqueueSnackbar(error, { variant: "error" });
            console.log(error);
          });
      })
      .catch((error) => {
        enqueueSnackbar(error, { variant: "error" });
        console.log(error);
      });
  };

  return (
    <>
      {props.patientData === undefined ? (
        <>
          <div className="uploadCont">
            <IconButton
              className={"showdiv" + (showDiv ? " showdivClose" : "")}
              onClick={() => setShowDiv(!showDiv)}
            >
              <Add className="addicon" fontSize="large" />
            </IconButton>
            {showDiv ? (
              <div className="uploadWrap">
                <input type="file" multiple onChange={fileSelectedHandler} />
                <button className="uploadBtn" onClick={MyDocsUpload}>
                  Upload
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
          <Divider style={{ margin: "10px 0px" }} />
        </>
      ) : (
        ""
      )}
      {props.qrscan !== "No result" ? (
        <div className="myDocs__ImageCont">
          {mydocObj === undefined ? (
            props.xray ? (
              <p>No X-rays Uploaded!</p>
            ) : (
              <p>No Prescriptions Uploaded!</p>
            )
          ) : (
            Object.keys(mydocObj).map((x) => {
              var url = mydocObj[x].url;
              return (
                <Paper elevation={7} className={classes.paper}>
                  <img
                    className="myDocs__ImageContImg"
                    src={url}
                    alt=""
                    onClick={() => {
                      myDocs__handleOpenClose(url);
                    }}
                  />
                  {props.patientData === undefined ? (
                    <button
                      style={imageRemove}
                      onClick={() => {
                        removeImage(url);
                      }}
                    >
                      &times;
                    </button>
                  ) : (
                    ""
                  )}
                </Paper>
              );
            })
          )}
          <Modal
            className={classes.modal}
            open={modalState}
            onClose={() => {
              myDocs__handleOpenClose(modalState);
            }}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={modalState}>
              <Paper
                elevation={7}
                className={classes.paper}
                style={{ width: "90%", maxWidth: "700px" }}
              >
                <img
                  style={{ width: "100%", borderRadius: "8px" }}
                  src={modalImage}
                  alt=""
                />
              </Paper>
            </Fade>
          </Modal>
        </div>
      ) : (
        <p>QR Code Not Scanned!</p>
      )}
    </>
  );
};

export default MyDocs;
